import { epochToDate } from "./utils";

export type Score = {
  nicks: Set<string>;
  ducks: Set<string>;
  points: number;
  firsts: number;
};

export type ApiError = { message: string };
export type FetchedSightings = {
  next?: string;
  sightings: Sighting[];
};

export type Sighting = {
  duck_id: string;
  timestamp: Date;
  user_id: string;
  nickname: string;
};

export type ApiOptions = {
  lambda: string;
  params: { next?: string };
};

async function fetchSightings(options: ApiOptions) {
  return fetch(options.lambda, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(options.params),
  })
    .then((response) => response.json())
    .then((data) => data as FetchedSightings | ApiError);
}

async function* getAllSightings(options: ApiOptions) {
  // Initial "next" param is empty
  const opts = { ...options };
  while (true) {
    const data = await fetchSightings(opts);
    if ("message" in data) {
      console.error(data.message);
      return;
    }
    const { next: newNext, sightings } = data;
    for (const sighting of sightings) {
      sighting.timestamp = epochToDate(sighting.timestamp as unknown as number);
      yield sighting as Sighting; // Yield each item one by one
    }
    if (!newNext) break; // Stop when "next" is empty
    opts.params.next = newNext;
  }
}

// Reduce-like function that processes sightings as they arrive
export async function processSightings<T>(
  reducer: (acc: T, s: Sighting) => T,
  initialValue: T,
  options?: ApiOptions
) {
  let accumulator = initialValue;
  for await (const sighting of getAllSightings(options)) {
    accumulator = reducer(accumulator, sighting);
  }
  return accumulator;
}
